import {ICalendarService} from '@lib/infrastructure';

const redirect_source = 'meet_consent';

const makeRedirectUri = (source: string, result: string, isTeamsApp: boolean) => {
  const {origin, pathname} = window.location;
  const params = new URLSearchParams({redirect_source: source, result, isTeams: `${isTeamsApp}`});

  return encodeURIComponent(`${origin}${pathname}?${params.toString()}`);
};

export const calendarService = (isTeamsApp = false): ICalendarService => {
  const getSuccessRedirectUrl = () => makeRedirectUri(redirect_source, 'success', isTeamsApp);
  const getFailureRedirectUrl = () => makeRedirectUri(redirect_source, 'reject', isTeamsApp);
  const getCancellationRedirectUrl = () => makeRedirectUri(redirect_source, 'failure', isTeamsApp);

  return {
    requestConsent: (consentUrl: string) => {
      document.location = consentUrl;
    },
    getCancellationRedirectUrl: getCancellationRedirectUrl,
    getFailureRedirectUrl: getFailureRedirectUrl,
    getSuccessRedirectUrl: getSuccessRedirectUrl,
  };
};
